import {z} from 'zod';

export const priceMappingSchema = z.object({
  newPrice: z.number(),
  initialPlanId: z.number(),
  newPlanId: z.number(),
  variantId: z.number(),
});

export type PriceMapping = z.infer<typeof priceMappingSchema>;
